// 引入request
import request from "@/utils/request";



// 登录方法
export function login(data) {
    return request({
      url: '/web/open/login',
      method: 'post',
      data: data,
      headers:{
        'Authorization':''
      }
    })
  }